import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccd56088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FAQ" }
const _hoisted_2 = { class: "custom-cover-container" }
const _hoisted_3 = {
  key: 0,
  class: "custom-cover-preview"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "cover-overlay" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择引流主体：", -1))
const _hoisted_7 = { class: "dialog-footer" }

import { searchFormConfig } from '@/views/main/helper/faq/config/search.config'
import { contentTableConfig } from '@/views/main/helper/faq/config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { editPageData, postData } from "@/service/main/system";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { ElMessage, ElMessageBox } from "element-plus";
import { useUpload } from "@/hooks/useUpload";
import { ref } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'FAQLibrary',
  setup(__props) {

const rowId = ref('')
const currCo = ref('4');
const coOptions = [
  {
    value: '1',
    label: '天鼎证券投资秦淮',
  },
  {
    value: '2',
    label: '南京秦淮天鼎证券投资',
  },
  {
    value: '3',
    label: '天鼎证券投顾',
  },
  {
    value: '4',
    label: '江苏天鼎',
  },
  {
    value: '5',
    label: '天鼎证券投资咨询',
  },
]
const dialogVisible = ref(false)
const handleClose = (done: () => void) => {
  //关闭弹窗时将公司id重置
  currCo.value='4'
  done()
}
const store = useStore()
const router = useRouter()
const addFAQ = () => {
  const reportUrl = router.resolve({
    path: '/main/helper/faq/FAQEditor',
    query: {
      opType: 'add',
    }
  }).href
  jump(reportUrl)
}

const editFAQ = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/helper/faq/FAQEditor',
    query: {
      opType: 'edit',
      faqId: item.id
    }
  }).href
  jump(reportUrl)
}

const jump = (reportUrl: any) => {
  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenHeight * 0.8

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2 - 50

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '功能窗口', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()
const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed] = useUpload()

const details = async (row: any) => {
  const url = `/main/faq/hitCount/${row.id}`
  await editPageData(url, {})
  const reportUrl = router.resolve({
    path: '/main/helper/faq/FAQDetail',
    query: {
      opType: 'edit',
      faqId: row.id
    }
  }).href
  jump(reportUrl)
}
const userInfo = store.state.login.userInfo

const copyLink = (row: any) => {
  const url = `https://cashroll.tdtz888.com/presales/index.html?sid=${userInfo.id}&articleId=${row.id}&id=4`
  navigator.clipboard.writeText(url)
  ElMessage.success('复制成功')
}
const showDialog = (row: any) => {
  dialogVisible.value = true;
  rowId.value = row.id;
}
// const copyLink = (row: any) => {
//   //复制链接
//   const url = `https://cashroll.yngw518.com/presales/index.html?sid=${userInfo.id}&articleId=${rowId.value}&id=${currCo.value}`
//   navigator.clipboard.writeText(url)
//   navigator.clipboard.writeText(url)
//   ElMessage.success('复制成功')

//   //关闭弹框
//   dialogVisible.value = false;
//   currCo.value = '4'

// }

let articleId = ''
const articleData = (row: any) => {
  articleId = row.id
}

const uploadSuccess = () => {
  postData("/main/faq/uploadCover", { id: articleId, cover: files.value[0] })
  files.value = []
  setTimeout(() => {
    const queryInfo = store.state.system.queryInfo
    pageContentRef.value?.getPageData(queryInfo)
  }, 1000)
}

const uploadExceed = () => {
  ElMessage.error('只能上传一张图片')
}

const deleteCover = async (row: any) => {
  ElMessageBox.confirm('确认删除文章封面？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    postData("/main/faq/deleteCover", { id: row.id })
    setTimeout(() => {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }, 1000)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "faq",
      deleteTip: "确认删除该条问答吗？",
      onNewBtnClick: addFAQ,
      onEditBtnClick: editFAQ
    }, {
      details: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (details(scope.row))
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_el_button, {
          size: "mini",
          type: "warning",
          onClick: ($event: any) => (copyLink(scope.row))
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制链接")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      cover: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          (scope.row.cover != null && scope.row.cover != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: scope.row.cover,
                  alt: '封面图片'
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini",
                    onClick: _withModifiers(($event: any) => (deleteCover(scope.row)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_el_upload, {
                key: 1,
                ref_key: "uploadRef",
                ref: uploadRef,
                multiple: "",
                "auto-upload": true,
                action: _unref(action),
                data: _unref(extraData),
                "before-upload": _unref(beforeUpload),
                "list-type": "text",
                accept: ".jpg, .jpeg, .png",
                "on-success": uploadSuccess,
                "on-exceed": uploadExceed,
                limit: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "success",
                    onClick: ($event: any) => (articleData(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传封面 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["action", "data", "before-upload"]))
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      title: "提示",
      width: "30%",
      "before-close": handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: copyLink
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 复制链接 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_component_el_select, {
            modelValue: currCo.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currCo).value = $event)),
            class: "m-2",
            placeholder: "公司名称",
            style: {"width":"240px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(coOptions, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})